var React = require('react');

function Q1 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Q1"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("path",{"d":"M59.56,10.81A39.1,39.1,0,0,0,8.14,8.57L63.62,62.85A39.1,39.1,0,0,0,59.56,10.81Z","transform":"translate(0 0)","fill":"#f47643","style":{"mixBlendMode":"multiply"},"key":0}),React.createElement("path",{"d":"M80,69.5,43.19,40.87h0L6.52,12.11,6,12.9a40,40,0,0,0,41,60.47v.06Z","transform":"translate(0 0)","fill":"#e5c83d","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

Q1.defaultProps = {"viewBox":"0 0 79.96 73.97"};

module.exports = Q1;

Q1.default = Q1;
